// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".longlist[data-v-d6318492]{max-height:500px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
